import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getSidebar } from "../services/api";

const TYPE_ICONS = { video:"🎥", slides:"📊", pdf:"📄", link:"🔗" };

export default function Sidebar({ activeId }) {
  const [sections, setSections] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    getSidebar().then(setSections).catch(() => {});
  }, []);

  if (sections.length === 0) return null;

  return (
    <aside className="sidebar">
      {sections.map((sec) => (
        <div className="sidebar-box" key={sec.id}>
          <div className="sidebar-header">
            <h3>{sec.name}</h3>
          </div>

          {sec.items?.length === 0 && (
            <p style={{ padding:".6rem 1rem", fontSize:"0.75rem", color:"var(--text-muted)" }}>
              Sin contenido aún.
            </p>
          )}

          <ul className="sidebar-list">
            {sec.items?.map((item) => {
              const isActive = String(item.id) === String(activeId);
              const isExternal = !item.url?.startsWith("/");

              return (
                <li key={item.id ?? item.url}>
                  {isExternal ? (
                    // Link externo — abre en nueva pestaña
                    <a
                      href={item.url}
                      target="_blank"
                      rel="noreferrer"
                      className={isActive ? "active" : ""}
                    >
                      {item.type && <span style={{ marginRight:4 }}>{TYPE_ICONS[item.type]}</span>}
                      {item.label}
                    </a>
                  ) : (
                    // Link interno — navega con React Router
                    <button
                      className={isActive ? "active" : ""}
                      onClick={() => navigate(item.url)}
                    >
                      {item.label}
                    </button>
                  )}
                </li>
              );
            })}
          </ul>
        </div>
      ))}
    </aside>
  );
}
